const reducer = (state, action) => ({
  ...state,
  addressName: action.result,
});

export default reducer;
